import { useState, useEffect } from "react";
import {
  Box,
  Stack,
  Typography,
  Autocomplete,
  TextField,
  Button,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import Detail from "../../main/detail/Detail";
import { readFromLS, writeToLS } from "../../util/LocalStrogeService";
import { useSnackbar } from "notistack";
import { rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { useNavigate } from "react-router-dom";
import useBreakpoints from "../../hooks/useBreakpoints";
import { Wheel } from "react-custom-roulette";

export default function Setting() {
  const navigate = useNavigate();

  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const { enqueueSnackbar } = useSnackbar();
  const { isSmall } = useBreakpoints();
  const [showCombo, setShowCombo] = useState(
    readFromLS("showCombo") ? readFromLS("showCombo") : false
  );

  const data = [
    { option: "0" },
    { option: "1" },
    { option: "2" },
    { option: "3" },
    { option: "4" },
    { option: "5" },
    { option: "6" },
    { option: "7" },
  ];

  const [mustSpin, setMustSpin] = useState(false);
  const [prizeNumber, setPrizeNumber] = useState(0);

  const handleSpinClick = () => {
    if (!mustSpin) {
      const newPrizeNumber = Math.floor(Math.random() * data.length);
      setPrizeNumber(newPrizeNumber);
      setMustSpin(true);
      enqueueSnackbar(
        `تبریک ! شما برنده ی ${newPrizeNumber} تومان اعتبار خرید شدید`,
        {
          variant: "success",
          autoHideDuration: 2000,
        }
      );
    }
  };

  const [factorPrint, setFactorPrint] = useState(
    localStorage.getItem("factorPrint")
      ? localStorage.getItem("factorPrint").replace(/['"]+/g, "")
      : ""
  );

  const [addresPrint, setAddresPrint] = useState(
    localStorage.getItem("addresPrint")
      ? localStorage.getItem("addresPrint").replace(/['"]+/g, "")
      : ""
  );
  const [sellerAddresPrint, setSellerAddresPrint] = useState(
    localStorage.getItem("sellerAddresPrint")
      ? localStorage.getItem("sellerAddresPrint").replace(/['"]+/g, "")
      : ""
  );

  let FactorPrints = ["A4", "A5"];
  let AddresPrints = ["با اقلام", "بدون اقلام"];
  let SellerAddresPrints = [" با آدرس مبدا", " بدون آدرس مبدا"];

  useEffect(() => {
    setMsActiveMenu({ id: undefined, pageTitle: "تنظیمات" });
  }, []);

  return (
    <Detail
      breadChilds={{
        // title: "اطلاعات پایه",
        childs: [{ name: "تنظیمات", url: "/setting" }],
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <Box display="grid" gap={3} gridTemplateColumns="repeat(12, 1fr)">
          <Box
            gridColumn={isSmall ? "span 12" : "span 3"}
            sx={{
              border: 1,
              p: 1,
              borderColor: "divider",
              justifyContent: "flex-start",
            }}
          >
            <Stack
              direction={"row"}
              sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}
            >
              <Typography color="inherit">پرینت فاکتور</Typography>
            </Stack>
            <Autocomplete
              sx={{ mt: -1 }}
              onChange={(evt, value) => {
                if (value) {
                  setFactorPrint(value);
                }
              }}
              disableClearable
              value={factorPrint ? factorPrint : ""}
              clearOnEscape
              disablePortal
              fullWidth
              size="small"
              options={FactorPrints ? FactorPrints : []}
              getOptionLabel={(option) => (option ? option : "")}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  placeholder="پرینت فاکتور"
                />
              )}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box
            gridColumn={isSmall ? "span 12" : "span 3"}
            sx={{
              border: 1,
              p: 1,
              borderColor: "divider",
              justifyContent: "flex-start",
            }}
          >
            <Stack
              direction={"row"}
              sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}
            >
              <Typography color="inherit">پرینت اقلام سفارش</Typography>
            </Stack>
            <Autocomplete
              sx={{ mt: -1 }}
              onChange={(evt, value) => {
                if (value) {
                  setAddresPrint(value);
                }
              }}
              disableClearable
              value={addresPrint ? addresPrint : ""}
              clearOnEscape
              disablePortal
              fullWidth
              size="small"
              options={AddresPrints ? AddresPrints : []}
              getOptionLabel={(option) => (option ? option : "")}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  placeholder="پرینت آدرس"
                />
              )}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box
            gridColumn={isSmall ? "span 12" : "span 3"}
            sx={{
              border: 1,
              p: 1,
              borderColor: "divider",
              justifyContent: "flex-start",
            }}
          >
            <Stack
              direction={"row"}
              sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}
            >
              <Typography color="inherit">پرینت آدرس مبدا</Typography>
            </Stack>
            <Autocomplete
              sx={{ mt: -1 }}
              onChange={(evt, value) => {
                if (value) {
                  setSellerAddresPrint(value);
                }
              }}
              disableClearable
              value={sellerAddresPrint ? sellerAddresPrint : ""}
              clearOnEscape
              disablePortal
              fullWidth
              size="small"
              options={SellerAddresPrints ? SellerAddresPrints : []}
              getOptionLabel={(option) => (option ? option : "")}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  placeholder="پرینت آدرس مبدا"
                />
              )}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          {/* <Box
            gridColumn="span 3"
            sx={{
              border: 1,
              p: 1,
              borderColor: "divider",
              justifyContent: "flex-start",
            }}
          >
            <Stack
              direction={"row"}
              sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}
            >
              <Typography color="inherit">نمایش لیست صفحه‌های نخست</Typography>
            </Stack>
            <FormControlLabel
              control={
                <Checkbox
                  checked={showCombo}
                  onChange={(event) => setShowCombo(event.target.checked)}
                />
              }
              label="نمایش لیست"
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>} */}

          <Box
            gridColumn={isSmall ? "span 12" : "span 3"}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Button variant="contained" onClick={() => submit()}>
              ثبت
            </Button>
          </Box>
        </Box>
        <Box
          sx={{
            flexGrow: 1,
            display: "flex",
            alignItems: "flex-end",
            justifyContent: "flex-end",
          }}
        >
          <Button sx={{ cursor: "default" }} variant="text">
            version : {localStorage.getItem("VersionCode")}
          </Button>
        </Box>
      </Box>
      {/* <>
        <Wheel
          mustStartSpinning={mustSpin}
          prizeNumber={prizeNumber}
          data={data}
          backgroundColors={["#A1D6CB", "#A19AD3"]}
          textColors={["#ffffff"]}
          outerBorderColor="#A19AD3"
          outerBorderWidth={5}
          innerBorderColor="#FFF"
          innerBorderWidth={5}
          radiusLineColor="#FFF"
          radiusLineWidth={4}
          pointerProps={{ backgroundColors: "black" }}
          onStopSpinning={() => {
            setMustSpin(false);
          }}
        />
        <Button variant="contained" onClick={handleSpinClick}>
          بچرخون
        </Button>
      </> */}
    </Detail>
  );

  function submit() {
    if (!factorPrint) {
      enqueueSnackbar("پرینت فاکتور را انتخاب کنید", {
        variant: "error",
        autoHideDuration: 2000,
      });
      return;
    }
    if (!addresPrint) {
      enqueueSnackbar("پرینت اقلام سفارش را انتخاب کنید", {
        variant: "error",
        autoHideDuration: 2000,
      });
      return;
    }
    if (!sellerAddresPrint) {
      enqueueSnackbar("پرینت آدرس مبدا را انتخاب کنید", {
        variant: "error",
        autoHideDuration: 2000,
      });
      return;
    }

    writeToLS("factorPrint", factorPrint);
    writeToLS("addresPrint", addresPrint);
    writeToLS("sellerAddresPrint", sellerAddresPrint);
    // writeToLS("showCombo", showCombo);

    enqueueSnackbar("با موفقیت ثبت شد", {
      variant: "success",
      autoHideDuration: 2000,
    });
    navigate("/orders");
    window.location.reload();
  }
}
